module.exports = __webpack_public_path__ + "img/icon-view-light.4227b22b.svg";